import { ofType, combineEpics } from 'redux-observable';
import _get from 'lodash/get';
import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { logout as corpLogout } from 'grab-login/lib/helper';
import { LINK_COMPANY } from 'actions/login-actions';
import { INVALID_TOKEN, LOG_OUT_CLEAN_UP } from 'actions/app-actions';
import { ERROR_MODAL_TYPE } from 'components/v2/error-modal/error-modal';
import { STORAGE_GFB_TOKEN } from 'constants/app-constants';
import {
  clearAuthResponses,
  clearGrabIdTokens,
  grabIDLogout,
} from 'helper/grab-id-auth-helper';
import { isPaxSelector } from 'selectors/app-selector';
import { getLogoutTargetUrl } from 'helper/auth-helper';
import { createPaxLinkPreConditionErrorModal } from './epic-helpers';

const userFeatureFlagEpic = (action$, state$) =>
  action$.pipe(ofType(LINK_COMPANY.SUCCESS), switchMap(() => EMPTY));

const checkPreConditionEpic = (action$, state$) =>
  action$.pipe(
    ofType(LINK_COMPANY.ERROR),
    switchMap(() => {
      const isFailedToVerifyPrecondition = _get(
        state$,
        'value.login.isFailedToVerifyPrecondition',
        false,
      );
      if (isFailedToVerifyPrecondition) {
        return of(
          createPaxLinkPreConditionErrorModal(
            ERROR_MODAL_TYPE.WARNING,
            'checkPreConditionEpic:LINK_COMPANY.ERROR',
          ),
        );
      }
      return EMPTY;
    }),
  );

const logoutEpic = (action$, state$) =>
  action$.pipe(
    ofType(INVALID_TOKEN),
    switchMap(() => {
      const isPax = isPaxSelector(state$.value);
      if (isPax) {
        const targetUrl = getLogoutTargetUrl();
        grabIDLogout()
          .then(() => {
            window.location.href = targetUrl;
          })
          .catch(() => {
            window.location.href = targetUrl;
          });
        return EMPTY;
      }
      corpLogout();
      return EMPTY;
    }),
  );

const logOutCleanUpEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOG_OUT_CLEAN_UP),
    switchMap(() => {
      // clean up token and auth info
      window.localStorage.removeItem(STORAGE_GFB_TOKEN);
      clearAuthResponses();
      clearGrabIdTokens();

      // prevent other unload listen to step redirecting
      window.addEventListener(
        'beforeunload',
        event => {
          event.stopImmediatePropagation();
        },
        true,
      );

      return EMPTY;
    }),
  );

export default combineEpics(
  userFeatureFlagEpic,
  logoutEpic,
  logOutCleanUpEpic,
  checkPreConditionEpic,
);
